import { CredentialsModel, UserModel, RetailExperienceUserModel } from 'models';
import { plainToClass } from 'class-transformer';
import { cookieHelper } from './cookieHelper';

const SOFOLOGY_SESSION_KEY = 'sofologySessionId';
const SOFOLOGY_USER_KEY = 'sofologyUser';
const SOFOLOGIST_KEY = 'sofologist';
const RETAIL_EXPERIENCE_USER_KEY = 'retailExperience.user';
const CUSTOMER_MIDDLENAME = 'customerMiddlename';
const LOG_SESSION_ID_KEY = 'logSessionId';

export class UserHelper {
    public getSessionId(): string | null {
        const sessionId = cookieHelper.getCookie(SOFOLOGY_SESSION_KEY);

        return sessionId ? JSON.parse(sessionId) : null;
    }

    public saveSessionId(sessionId: string): void {
        cookieHelper.setCookie(SOFOLOGY_SESSION_KEY, JSON.stringify(sessionId));
    }

    public getUser(): UserModel | null {
        const userData = cookieHelper.getCookie(SOFOLOGY_USER_KEY);
        const userJson = userData ? userData.replace(/(%[0-9A-Z]{2})+/gi, decodeURIComponent) : null;

        return userJson ? plainToClass(UserModel, JSON.parse(userJson)) : null;
    }

    public getRetailExperienceUser(): RetailExperienceUserModel | null {
        const userJson = cookieHelper.getCookie(RETAIL_EXPERIENCE_USER_KEY);

        return userJson ? plainToClass(RetailExperienceUserModel, JSON.parse(userJson)) : null;
    }

    public saveRetailExperienceUser(userId: string, username: string): void {
        let oldRetailExperienceUser = this.getRetailExperienceUser();

        const updatedRetailExperienceUser: RetailExperienceUserModel | null = { ...oldRetailExperienceUser, userId, username };

        cookieHelper.setCookie(RETAIL_EXPERIENCE_USER_KEY, JSON.stringify(updatedRetailExperienceUser));
    }

    public getStaffUser(): UserModel | null {
        const staffUserJson = cookieHelper.getCookie(SOFOLOGIST_KEY);

        return staffUserJson ? plainToClass(UserModel, JSON.parse(staffUserJson)) : null;
    }

    public isUserLoggedIn(): boolean {
        const user = this.getUser();

        return Boolean(user?.username);
    }

    public getCurrentUserName(): string | null {
        const user = this.getUser();

        return user ? user.username : null;
    }

    public clearUserSession(): void {
        if (this.getUser()) {
            cookieHelper.removeCookie(SOFOLOGY_USER_KEY);
        }

        if (this.getStaffUser()) {
            cookieHelper.removeCookie(SOFOLOGIST_KEY);
        }

        if (this.getRetailExperienceUser()) {
            cookieHelper.removeCookie(RETAIL_EXPERIENCE_USER_KEY);
        }

        if (this.getSessionId()) {
            cookieHelper.removeCookie(SOFOLOGY_SESSION_KEY);
        }
    }

    public saveCredentials(creds: CredentialsModel, username: string | null = null): void {
        const user = new UserModel(
            username,
            creds.tokenType + ' ' + creds.accessToken,
            creds.refreshToken,
            new Date().getTime().toString(),
            creds.userId
        );

        cookieHelper.setCookie(SOFOLOGY_USER_KEY, user);
        this.removeItem(SOFOLOGY_SESSION_KEY);
    }

    public removeSessionId(): void {
        cookieHelper.removeCookie(SOFOLOGY_SESSION_KEY);
    }

    public saveCustomerMiddlename(middlename: string): void {
        localStorage.setItem(CUSTOMER_MIDDLENAME, middlename);
    }

    public getCustomerMiddlename(): string | null {
        return localStorage.getItem(CUSTOMER_MIDDLENAME);
    }

    public saveLogSessionId(sessionId: string): void {
        localStorage.setItem(LOG_SESSION_ID_KEY, sessionId);
    }

    public getLogSessionId(): string | null {
        return localStorage.getItem(LOG_SESSION_ID_KEY);
    }

    private removeItem(key: string): void {
        cookieHelper.removeCookie(key);
        localStorage.removeItem(key);
    }
}

export const userHelper = new UserHelper();